import { render, staticRenderFns } from "./CertificationManage.vue?vue&type=template&id=2f6f811c&scoped=true&"
import script from "./CertificationManage.vue?vue&type=script&lang=js&"
export * from "./CertificationManage.vue?vue&type=script&lang=js&"
import style0 from "./CertificationManage.vue?vue&type=style&index=0&id=2f6f811c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f811c",
  null
  
)

export default component.exports